<template>
  <div class="modal_wrapper">
    <div class="container">
      <div class="modal_container">
        <div class="modal_header">
          <img :src="caution" height="25px" />
          {{ title }}
        </div>
        <div class="modal_body">
          <div class="body" v-html="question"></div>
          <div class="modal_buttons">
            <input
              type="button"
              :value="cancelButton"
              class="cancel_button"
              @click="$emit('close')"
            />
            <input
              type="button"
              :value="okButton"
              class="finish_button"
              @click="$emit('ok')"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['title', 'question'],
  data() {
    return {
      caution: require('../../img/caution.png'),
      cancelButton: 'キャンセル',
      okButton: 'OK'
    }
  }
}
</script>
<style scoped>
.modal_wrapper {
  background-color: rgba(0, 0, 0, 0.5);
}
.container {
  display: table-cell;
  vertical-align: middle;
}
.body {
  width: 100%;
  padding-top: 40px;
  padding-bottom: 20px;
  text-align: left;
}
.modal_container,
.modal_body {
  height: auto;
}
.modal_buttons {
  position: static;
  text-align: right;
  padding-bottom: 20px;
  font-size: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/modalWindow/confirmCustomTitleModalWindow.vue